"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_beforeunload_1 = require("react-beforeunload");
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const eventConstants_1 = require("../../constants/eventConstants");
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const navBar_1 = __importDefault(require("../../components/navBar/navBar"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const queueCommunicationBox_1 = __importDefault(require("../../components/communicationBox/queueCommunicationBox"));
const officersSlice_1 = require("../officer/officersSlice");
const constants_1 = require("../../constants/constants");
const navigationButton_1 = __importDefault(require("../../components/button/navigationButton"));
const supportSlice_1 = require("./supportSlice");
const callLog_1 = __importDefault(require("../../components/callLog/callLog"));
const communicationBoxUtils_1 = require("../../components/communicationBox/communicationBoxUtils");
const ticketSlice_1 = require("../ticket/ticketSlice");
const ticketTable_1 = __importDefault(require("../../components/ticketComponent/ticketTable"));
const modal_1 = __importDefault(require("../../components/modal/modal"));
const ticketForm_1 = __importDefault(require("../../components/ticketComponent/ticketForm"));
const colors_1 = __importDefault(require("../../styles/colors"));
const eventQueueBox_1 = __importDefault(require("../../components/event/eventQueueBox"));
const userCustomerInfo_1 = __importDefault(require("../../components/customerInfo/userCustomerInfo"));
const utils_1 = require("../../utils/utils");
const Support = () => {
    const dispatch = useAppDispatch_1.default();
    const [modalVisible, setModalVisible] = react_1.useState(false);
    const [showTicketingSystem, setShowTicketingSystem] = react_1.useState(false);
    const [createTicketModalVisible, setCreateTicketModalVisible] = react_1.useState(false);
    const { customer, callerInbound, ticketCount, selectedTicket } = useAppSelector_1.default((state) => ({
        customer: state.support.customer,
        officerId: state.auth.user.id,
        officerMetrics: state.campaign.officerMetrics,
        callerInbound: state.communication.callerInbound,
        ticketCount: state.ticket.totalEntries,
        selectedTicket: state.ticket.selectedTicket,
    }));
    const phoneNumber = communicationBoxUtils_1.parseInboundContact(callerInbound);
    react_1.useEffect(() => {
        // Do a basic phone number validation before making a request or showing ticket form.
        if (communicationBoxUtils_1.validatePhoneNumber(phoneNumber)) {
            setShowTicketingSystem(false);
            return;
        }
        setShowTicketingSystem(true);
        dispatch(supportSlice_1.getCustomerDetails({ phone_number: phoneNumber }));
        dispatch(ticketSlice_1.getTickets({ phone_number: phoneNumber }));
    }, [phoneNumber]);
    const clearSchedule = async () => {
        await dispatch(supportSlice_1.resetSupportState());
    };
    const onPageChange = (page) => {
        dispatch(ticketSlice_1.getTickets({ phone_number: phoneNumber, page }));
    };
    const showTicketDetails = ({ ticket }) => {
        dispatch(ticketSlice_1.setSelectedTicket(ticket));
        setModalVisible(true);
    };
    // Especially on mobile, the beforeunload event is not reliably fired. For example, the beforeunload event is not fired at all in the following scenario:
    // A mobile user visits your page -> The user then switches to a different app -> Later, the user closes the browser from the app manager
    // On tab close or broswer close set the officer status to puase.
    react_beforeunload_1.useBeforeunload(() => dispatch(officersSlice_1.updateOfficerStatus({ status: constants_1.OFFICER_STATUS_PAUSED })));
    return (react_1.default.createElement(navBar_1.default, null,
        react_1.default.createElement(react_native_1.View, { style: [styles_1.default.flexDirectionRow, styles_1.default.alignSpaceBetween] },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.marginTen] },
                react_1.default.createElement(boxTitle_1.default, { title: "Support" })),
            !!customer && (react_1.default.createElement(navigationButton_1.default, { onPress: clearSchedule, title: "Back", event: eventConstants_1.NAVIGATE_DASHBOARD_BUTTON }))),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.flexOne },
            react_1.default.createElement(eventQueueBox_1.default, null),
            react_1.default.createElement(queueCommunicationBox_1.default, null)),
        !utils_1.isObjectEmpty(customer) && react_1.default.createElement(userCustomerInfo_1.default, { user: customer }),
        showTicketingSystem && (react_1.default.createElement(react_native_paper_1.Button, { buttonColor: colors_1.default.BLUE_2, textColor: colors_1.default.WHITE, icon: "information", mode: "elevated", onPress: () => setCreateTicketModalVisible(true) }, 'Create Ticket ')),
        showTicketingSystem && !!ticketCount && (react_1.default.createElement(ticketTable_1.default, { onTicketPress: showTicketDetails, onPageChange: onPageChange })),
        react_1.default.createElement(react_native_1.View, { style: styles_1.default.boxStyles },
            react_1.default.createElement(callLog_1.default, null)),
        react_1.default.createElement(modal_1.default, { title: "Create Ticket", visible: createTicketModalVisible, hideModal: () => setCreateTicketModalVisible(false), containerStyle: styles_1.default.modelFormTop },
            react_1.default.createElement(ticketForm_1.default, { ticket: null, user: customer })),
        react_1.default.createElement(modal_1.default, { title: selectedTicket ? 'View Ticket' : 'Create Ticket', visible: modalVisible, hideModal: () => setModalVisible(false), containerStyle: styles_1.default.modelFormTop },
            react_1.default.createElement(ticketForm_1.default, { ticket: selectedTicket, readonly: !!selectedTicket }))));
};
exports.default = Support;
